import React, { useState, useEffect } from 'react'
import LoginHeader from '../../../Login_header'
import Menu from '../../../Menu'
import { Container, Form, Row, Col, Button } from 'react-bootstrap';
import * as Common from './../../../Common';
import Dialog from './../../../Dialog';
import { useNavigate } from 'react-router-dom';
import $ from "jquery";

const VTM_status_report = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [statusFrom, setStatusFrom] = useState("");
    const [statusProduct, setStatusProduct] = useState("VTM");
    const [statusType, setStatusType] = useState("V");
    const [radioType, setRadioType] = useState("A");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_MIS_VTM_STATUS'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleGenerate = () => {
        $(".loader").show();
        if (statusFrom === "") {
            setMsgText("Please fill From.");
            setMsgBox(true);
            $(".loader").hide();
        } else {
            const obj = {
                statusFrom: statusFrom,
                statusProduct: statusProduct,
                type: statusType,
                radioTypeLocation: radioType,
            };
            if (statusType === 'D') {
                Common.callDownloadApiPost1(Common.apiVTMStatusReport, "post", [sid, 'getData', JSON.stringify(obj)], (result) => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else if (statusType === 'V') {
                Common.callApi(Common.apiVTMStatusReport, [sid, 'getData', JSON.stringify(obj)], (result) => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });
            }
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h4>VTM Status Report</h4>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={statusType} onChange={e => setStatusType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Product<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={statusProduct} onChange={e => setStatusProduct(e.target.value)}
                                required>
                                <option value="VTM">VTM</option>
                                <option value="EVTM">EVTM</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>From<span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" placeholder="From" maxLength={50}
                                value={statusFrom}
                                onChange={(e) => setStatusFrom(e.target.value)}
                                autoComplete="off" />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default VTM_status_report
